import React from 'react'
import Switch from '@material-ui/core/Switch'

import FormControlLabel from '@material-ui/core/FormControlLabel'
const toggle = ({ inputValue, changed, disabled, color, label }) => {
  return (
    <FormControlLabel
      control={<Switch disabled={disabled} checked={inputValue} onChange={changed} color={color} />}
      label={label}
    />
  )
}

export default toggle
